<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500">
      <a role="button" class="underline" @click.prevent="selectContact">
        {{ fullName }}
      </a>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <ul v-if="contact.email_addresses && contact.email_addresses.length">
        <li v-for="emailAddress in contact.email_addresses" :key="emailAddress.id">
          {{ emailAddress.address }}
        </li>
      </ul>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <ul v-if="contact.phone_numbers && contact.phone_numbers.length">
        <li v-for="phoneNumber in contact.phone_numbers" :key="phoneNumber.id">
          {{ phoneNumber.number }}
        </li>
      </ul>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <span class="whitespace-nowrap">
        {{ createdAtShort }}
      </span>
      <p>
        {{ createdAtFromNow }}
      </p>
    </td>
  </tr>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullName() {
      if (typeof this.contact?.full_name === 'string') {
        return this.contact.full_name;
      }

      return `${this.contact?.first_name || ''} ${this.contact?.last_name || ''}`.trim();
    },
    createdAt() {
      return moment.utc(this.contact.created_at).local();
    },
    createdAtShort() {
      return this.createdAt.format('DD-MM-YYYY');
    },
    createdAtFromNow() {
      return this.createdAt.fromNow();
    },
  },
  methods: {
    selectContact() {
      this.$emit('select', this.contact);
    },
  },
};
</script>
